export const DEFAULT_SHOP_ITEMS_PER_PAGE = 12
